import React, { useEffect } from 'react';
import { Divider, Grid, Theme, useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import {
  COLOR_LIGHT_GRAY,
  COLOR_WHITE,
  EXT_INFO_SCREEN_TYPE
} from '../../const/Const';
import { useRecoilState } from 'recoil';
import { mainBlueColor } from '../../GlobalState';
import { TInfoBox, TInfoData } from '../../types/ExtInfoBox';
import { Info } from './Info';
import { UseFormRegister } from 'react-hook-form';
import HelpIcon from '@material-ui/icons/Help';
import { CustomTooltip } from '../tooltip/CustomTooltip';
import { tooltipContents } from '../tooltip/Const';

type TProps = {
  boxData: TInfoBox;
  boxNo: number;
  register: any;
  setValue: any;
  errors: any;
  ext_info_screen_type: number;
};

const customTooltipContent = (ext_info_screen_type: number) => {
  switch (ext_info_screen_type) {
    case EXT_INFO_SCREEN_TYPE.CONSTRUCT:
      return tooltipContents.constructionsExtInfoBox;
    case EXT_INFO_SCREEN_TYPE.CLIENT:
      return tooltipContents.clientExtInfoBox;
    default:
      return <></>;
  }
};

export const Boxes: React.FC<TProps> = (props: TProps) => {
  const { boxData, boxNo, register, setValue, errors, ext_info_screen_type } =
    props;

  const dataList: TInfoData[] = boxData.list.filter(data => data.item);

  const matches2 = useMediaQuery('(min-width:900px)');
  const [mainColor] = useRecoilState(mainBlueColor);
  const classes = useStyles({ mainColor: mainColor });

  return (
    <>
      <div style={{ margin: 15 }}>
        <div>
          <div
            style={{
              backgroundColor: '#FFFFFF',
              display: 'flex',
              alignItems: 'center',
              paddingBottom: '15px'
            }}
          >
            <div
              style={{
                fontWeight: 'bold',
                padding: 15,
                paddingBottom: 0,
                fontSize: 24,
                marginRight: 5
              }}
            >
              {boxData.name}
            </div>
            <CustomTooltip
              title={customTooltipContent(ext_info_screen_type)}
              interactive
              placement='left'
            >
              <HelpIcon
                color='action'
                style={{ marginTop: 16, marginLeft: 8 }}
              />
            </CustomTooltip>
          </div>
          <Grid
            container
            style={{
              backgroundColor: '#FFFFFF',
              paddingBottom: 15,
              marginBottom: 15
            }}
          >
            <Grid item xs={matches2 ? 6 : 12}>
              {dataList &&
                dataList.length > 0 &&
                dataList.map((data: TInfoData, index: number) => (
                  <Info
                    data={data}
                    boxNo={boxNo}
                    index={index}
                    register={register}
                    setValue={setValue}
                    errors={errors}
                    key={index}
                  />
                ))}
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

type TStyleProps = {
  mainColor: string;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({
    subContainer: {
      marginLeft: 15,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row'
    },
    textMainContainer: {
      display: 'flex',
      backgroundColor: props => props.mainColor,
      width: '50%',
      minHeight: 60,
      alignItems: 'center'
    },
    textContainer: {
      marginLeft: 15,
      color: '#FFFFFF',
      fontSize: 14
    },
    inputMainContainer: {
      display: 'flex',
      backgroundColor: '#F5F5F5',
      minHeight: 60,
      alignItems: 'center',
      width: '100%'
    },
    inputContainer: {
      marginLeft: 10,
      marginRight: 10,
      paddingRight: 10,
      width: '100%'
    },
    input: {
      minHeight: 40,
      width: '100%',
      borderColor: '#c1c1c1',
      borderWidth: 1
    }
  })
);
